if (!window.csapps) {
  console.log("Issue loading discount prices");
}

const waitForTableToExist = (selector) => {
  return new Promise((resolve) => {
    if (document.querySelector(selector)) {
      return resolve(document.querySelector(selector));
    }

    const observer = new MutationObserver(() => {
      if (document.querySelector(selector)) {
        resolve(document.querySelector(selector));
        observer.disconnect();
      }
    });

    const observerOptions = {
      childList: true,
      subtree: true,
    };

    observer.observe(document.body, observerOptions);
  });
};

const getOnlyNumbers = (inputString) => inputString.replace(/[^0-9\.]+/g, "");

const addRowToTable = (i, price) => {
  const originalPriceLine = document.createElement("tr");
  const vatPrice = document.createElement("td");
  const exVatPrice = document.createElement("td");
  vatPrice.appendChild(document.createTextNode("1-3"));
  exVatPrice.appendChild(document.createTextNode(`${price.innerText}`));
  originalPriceLine.appendChild(vatPrice);
  originalPriceLine.appendChild(exVatPrice);
  i.prepend(originalPriceLine);
};

const addTableLinesAndColumn = (productPrice) => {
  const tableContainer = document.getElementById("tableContainer");

  const formatFinance = (number) =>
    new Intl.NumberFormat("en-UK", {
      style: "currency",
      currency: "GBP",
    }).format(number);

  const takePercentageFromAmount = (p, op) => {
    const percentage = Number(p);
    const originalPrice = op.length >= 1 ? Number(op[0]) : Number(op);
    const percentageOffPrice =
      originalPrice - Math.floor(percentage * originalPrice).toFixed(2) / 100;
    return formatFinance(percentageOffPrice);
  };

  const findDiscountTable = tableContainer.querySelectorAll("TABLE");

  const discountTableElement = [...findDiscountTable].filter(
    (i) => i.className === "csapps-table table"
  );

  discountTableElement.forEach((table) => {
    Array.from(table.children).forEach((i) => {
      if (i.tagName === "THEAD") {
        const tableRows = Array.from(i.children);
        tableRows.forEach((headerRow) => {
          const newHeaderCell = document.createElement("th");
          newHeaderCell.innerText = "Price (Inc VAT)";
          headerRow.insertBefore(newHeaderCell, headerRow.children[1]);
        });
      } else if (i.tagName === "TBODY") {
        addRowToTable(i, productPrice);
        const tableRows = Array.from(i.children);
        const initTableData = tableRows.map((row) => [
          row.children[0].innerHtml,
          row.children[1].innerText.match(/[-]{0,1}[\d]*[.]{0,1}[\d]+/g),
        ]);
        tableRows.forEach((tableRow, i) => {
          const newDataCell = document.createElement("td");
          const leftCell = tableRow.children[0];
          const rightCell = tableRow.children[1];
          if (i >= 1) {
            rightCell.innerText = takePercentageFromAmount(
              initTableData[i][1],
              productPrice
                .replace(/,/g, "")
                .match(/[-]{0,1}[\d]*[.]{0,1}[\d]+/g)
            );
          } else {
            rightCell.innerText = formatFinance(productPrice);
          }

          newDataCell.innerText = formatFinance(
            justNumbers(rightCell.innerText) * 1.2
          );

          tableRow.insertBefore(newDataCell, tableRow.children[1]);

          if (leftCell.innerText.includes("+")) {
            const removeMinus = leftCell.innerText.replace("-", "");
            leftCell.innerText = removeMinus;
          }
        });
      }
    });
  });
};

const tableChanges = () => {
  const productPriceElement = document.getElementById(
    "product__price__current"
  );
  const productPrice = getOnlyNumbers(
    productPriceElement.childNodes[0].nodeValue
  );

  addTableLinesAndColumn(productPrice);
};
document.addEventListener("DOMContentLoaded", () => {
  waitForTableToExist(".csapps-table")
    .then(() => {
      tableChanges();
    })
    .catch((err) => console.log("Error loading price table", err));
});
